import React from 'react';
import { Container, Table } from 'react-bootstrap';
import { isNull, isUndefined } from 'lodash';

import { BackButton, CopyLinkButton, Loading, LoadingError } from '@components/Base';
import HeaderSecondary from '@components/HeaderSecondary';

import { useCancerQuotesFetch } from './hook';
import { TableInsurer } from './table-insurer';
import { TableAnnualLimit } from './table-annual-limit';
import { TableGeographicCoverage } from './table-geographic-coverage';
import { TableBenefit } from './table-benefit';

const CancerQuoteComparePage = () => {
  const cancerQuotes = useCancerQuotesFetch();

  if (isUndefined(cancerQuotes)) return <Loading />;
  if (isNull(cancerQuotes)) return <LoadingError />;

  return (
    <>
      <HeaderSecondary />

      <Container className="mt-4">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <BackButton />
          <CopyLinkButton />
        </div>

        <Table>
          <tbody>
            <TableInsurer />
            <TableAnnualLimit />
            <TableBenefit />
            <TableGeographicCoverage />
          </tbody>
        </Table>
      </Container>
    </>
  );
};

export { CancerQuoteComparePage };
